import * as DictionaryConstants from '../../../../../constants/DictionaryConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      pageNum: 1,
      pageSize: 10,
      pageOrder: 'desc',
      pageSort: 'id',
      centerHeight: document.documentElement.clientHeight - 160 +'px',
      type: '0',
      carList: [],
      centerDialogVisible: false,
      qrCode:'',
      activeIndex: '0'
    }
  },
  computed: {
    ...mapState('myStoredValueModule', ['myStoredValue','storedValueCardDefinitionList']),
    myStoredValueInfo () {
      return this.myStoredValue
    },
    storedValueCardDefinitionListInfo () {
      return this.storedValueCardDefinitionList
    }
  },
  methods: {
    ...mapActions('myStoredValueModule', ['getMemberStoredValue','getMemberStoredValueCardDefinitionId']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    generateUrl (content) {
      this.centerDialogVisible = true
      this.qrCode = `//${location.host}/api/qr/generate?content=${content}&X-Authorization=${localStorage.getItem('token')}`
    },
    handleSelect (key, keyPath) {
      this.getMemberStoredValueInfo(key+'')
    },
    getMemberStoredValueInfo (type) {
      if (type) {
        this.type = type
      }
      let pageData = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pageSort: this.pageSort,
        pageOrder: this.pageOrder,
      }
      if (this.type !== '0') {
        pageData.expenditureOrIncome = type * 1
      }
      this.getMemberStoredValue(pageData)
    },
    load () {
      this.pageSize += 10
      this.getMemberStoredValueInfo(this.type)
    },
    openStoredValueDetails () {
      this.$router.push({
        path: RoutePathConstants.CARD_OPERATION_SEARCH
      })
    }
  },
  mounted () {
    this.getMemberStoredValueInfo()
    // let carList = JSON.parse(this.$route.query.list)
    // this.getMemberStoredValueCardDefinitionId(carList)
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/my-stored-value/views/my-stored-value-details.js